<template>
  <z-expansion-config-item 
    titulo="Categoria Padrão Contas a Pagar" 
    subtitulo="Selecione a categoria padrão para contas a pagar no sistema"
  >
    <v-autocomplete
      v-model="store.configuracoes.CATEGORIA_CONTAS_PADRAO"
      dense
      filled
      hide-details
      style="width: 300px"
      :items="listasStore.contas_pagar_categorias"
      @change="updateConfig"
    ></v-autocomplete>
  </z-expansion-config-item>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import { useListasStore } from '@/app/store/pinia/listas.js';
import queryBuilder from '@/app/helpers/QueryBuilder';

import listasApi from '@/app/services/listas'

const store = useConfigStore();
const listasStore = useListasStore();
const clientes = ref([]);

onMounted(async () => {
  await listasStore.fetchListas([
    queryBuilder()
      .from("ContaPagarCategoria")
      .selectraw("id as value, descricao as text, tipo")
      .orderBy("descricao")
      .where("tipo='Despesa'")
      .build(),
  ]);

});

function updateConfig() {
  store.salvarConfiguracao({
    config: 'CATEGORIA_CONTAS_PADRAO',
    valor: store.configuracoes.CATEGORIA_CONTAS_PADRAO,
    tipo: 'integer',
    descricao: 'Categoria Padrão Contas a Pagar',
    ajuda: 'Selecione a categoria padrão para contas a pagar no sistema'
  });
}

</script>

<style lang="scss" scoped>

</style>
